import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class ConfigDebtService {
  private API_CONFIGDEBT_URL = environment.API_URL + "api/configuration/debt";
  private API_CONFIGDEBT_FIND_URL = environment.API_URL + "api/configuration/finddebt";

  constructor(private http: HttpClient) {}

  getConfigDebts() {
    return this.http.get(this.API_CONFIGDEBT_URL);
  }

  getConfigDebt(id: any) {
    return this.http.get(`${this.API_CONFIGDEBT_FIND_URL}/${id}`);
  }

  createDebtConfig(value: any) {
    return this.http.post(this.API_CONFIGDEBT_URL, value);
  }

  updateDebtConfig(value: any, id: number) {
    value.id = id;
    return this.http.put(`${this.API_CONFIGDEBT_URL}/${id}`, value);
  }
}
